module.exports = __webpack_public_path__ + "img/textarea.0e7e616c.svg";